import React, { useState, useContext } from 'react';
import { Typography, TextField, Button, Box } from '@mui/material';
import { default as Grid } from '@mui/material/Grid2';
import { UserContext } from '../../../contexts/UserContext'; // Import UserContext

export default function Email() {
    const { user } = useContext(UserContext); // Access user information
    const [input, setInput] = useState({
        newEmail: '',
    });
    const [message, setMessage] = useState(''); // Replace with actual status message logic

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleChangeEmail = (e) => {
        e.preventDefault();
        console.log('Cambio de correo:', input.newEmail);
        setMessage('Solicitud de cambio de correo enviada.');
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Administrar correo electrónico
            </Typography>
            {message && (
                <Typography color="error" gutterBottom>
                    {message}
                </Typography>
            )}
            <form onSubmit={handleChangeEmail} name="change-email" method="post">
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            variant="standard"
                            fullWidth
                            label="Correo actual"
                            value={user?.email || ''}
                            disabled
                            placeholder="Su correo actual"
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            variant="standard"
                            fullWidth
                            label="Nuevo correo"
                            name="newEmail"
                            value={input.newEmail}
                            onChange={handleChange}
                            helperText="Por favor, ingrese su nuevo correo electrónico."
                            inputProps={{
                                autoComplete: 'email',
                                'aria-required': 'true',
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                        >
                            Cambiar correo
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}
